import {
  Controller,
  type Control,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form'

import type { FieldProps, FieldSpec } from './field-props'
import { ColorField } from './color-field'
import { TextField } from './text-field'

export function FormField<T extends FieldValues>({
  control,
  name,
  spec,
  disabled = false,
  describedBy,
  className,
  autoFocus,
  autoComplete,
  required,
  maxLength,
  onKeyDown,
}: {
  control: Control<T>
  name: FieldPath<T>
  spec: FieldSpec
  disabled?: boolean
  describedBy?: string
  className?: string
  autoFocus?: boolean
  autoComplete?: string
  required?: boolean
  maxLength?: number
  onKeyDown?: FieldProps['onKeyDown']
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const Component = spec.kind === 'color' ? ColorField : TextField
        return (
          <Component
            {...(autoFocus === undefined ? {} : { autoFocus })}
            ref={field.ref}
            className={className}
            name={field.name}
            label={spec.label}
            kind={spec.kind ?? 'text'}
            hint={spec.hint}
            placeholder={spec.placeholder}
            autoComplete={autoComplete}
            required={required}
            maxLength={maxLength}
            onKeyDown={onKeyDown}
            value={field.value as string}
            error={fieldState.error?.message}
            disabled={disabled}
            describedBy={describedBy}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        )
      }}
    />
  )
}
